import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TabPanelProps } from "../../types/helpers/types";
import { trackEventMatomo } from '../../helpers/matomo';
import ResearchesComp from "./ResearchesComp";
import ResearchesModels from "./ResearchesModels";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function ResearchesTabs() {
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    trackEventMatomo('pesquisas legado', 'click', 'aba', newValue === 0 ? 'respostas' : 'modelos');
    setValue(newValue);
  };
  const { t } = useTranslation('translation');

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          textColor="secondary"
          indicatorColor="secondary" value={value}
          onChange={handleChange}
        >
          <Tab label={t('researchesPage.researches.answers')} value={0} />
          <Tab label={t('researchesPage.researches.templates')} value={1} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <ResearchesComp />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ResearchesModels />
      </CustomTabPanel>
    </>
  );
}
